package kz.dentalcrm.app.screens.protocols.list

import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate
import kz.dentalcrm.app.domain.TreatmentRepository
import kz.dentalcrm.app.screens.protocols.list.mvi.ProtocolsViewEvent
import kz.dentalcrm.app.screens.protocols.list.mvi.ProtocolsViewState
import kz.dentalcrm.app.screens.protocols.list.mvi.ProtocolsViewSideEffect
import org.koin.core.component.inject

class ProtocolsViewModel :
    BaseStateViewModel<ProtocolsViewEvent, ProtocolsViewState, ProtocolsViewSideEffect>() {

    private val diagnosisRepository: TreatmentRepository by inject()

    override fun setInitialState() = ProtocolsViewState()

    private var currentPage: Int = 1
    private var _isLastPage: Boolean = false

    private val treatmentList = mutableListOf<ProtocolTemplate>()

    override fun handleEvents(event: ProtocolsViewEvent) {
        when (event) {
            is ProtocolsViewEvent.SearchProtocol -> {
                _isLastPage = false
                currentPage = 1
                treatmentList.clear()
                setState {
                    copy(
                        search = event.search,
                        treatments = persistentListOf()
                    )
                }
                loadServices(
                    delayMillis = 300L
                )
            }
            ProtocolsViewEvent.LoadMore -> {
                loadServices()
            }
            ProtocolsViewEvent.Reload -> {
                _isLastPage = false
                currentPage = 1
                treatmentList.clear()
                setState {
                    copy(
                        treatments = persistentListOf()
                    )
                }
                loadServices(delayMillis = 1500L)
            }
            is ProtocolsViewEvent.EditProtocol -> {
                setEffect {
                    ProtocolsViewSideEffect.ShowEditService(
                        service = event.service
                    )
                }
            }
            is ProtocolsViewEvent.DeleteProtocol -> {
                treatmentList.removeAll { it.id == event.id }
                setState {
                    copy(treatments = treatmentList.toPersistentList())
                }
            }
        }
    }

    private fun loadServices(
        delayMillis: Long = 0L
    ) {
        if (_isLastPage) {
            return
        }
        setState {
            copy(
                screenState = ProtocolsViewState.ScreenState.Loading
            )
        }
        launch(Dispatchers.Default) {
            delay(delayMillis)
            diagnosisRepository.getTreatments(
                search = viewState.value.search,
                page = currentPage
            ).stateHandle(
                onError = { _, message ->
                    setState {
                        copy(
                            screenState = ProtocolsViewState.ScreenState.Error(
                                text = message
                            )
                        )
                    }
                },
                onFailure = {
                    setState {
                        copy(
                            screenState = ProtocolsViewState.ScreenState.Error(
                                text = "Произошла неожиданная ошибка"
                            )
                        )
                    }
                },
                onSuccess = { data ->
                    treatmentList.addAll(data ?: emptyList())
                    currentPage++
                    setState {
                        copy(
                            treatments = treatmentList.toPersistentList(),
                            screenState = ProtocolsViewState.ScreenState.Idle
                        )
                    }
                    _isLastPage = (data?.size ?: 0) < PAGE_SIZE
                }
            )
        }
    }

    init {
        loadServices()
    }

    companion object {
        private const val PAGE_SIZE = 10
    }
}